import React, { useEffect } from 'react'
import { useState } from 'react'
import { Bars } from 'react-loader-spinner'
import { useParams } from 'react-router-dom'
import characters from "../../assets/media/success/characters.png"
import { useNavigate } from 'react-router-dom'


const ErrorPage = () => {
    const navigate = useNavigate()
    const [loader] = useState(false)
    const { plan } = useParams()

    console.log("Error Page page", plan)

    const plans = {
        free: "Free Trial",
        standard: "Standard Plan",
        premium: "Premium Plan",
    }

    useEffect(() => {
    }, [navigate])

    return (

        <div className={`thanksScreen h-screen flex justify-center items-center bg-[#333333]`}>
            {

                loader ?
                    <Bars
                        height="80"
                        width="80"
                        color="#ffe501"
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                    :

                    <div className="container  w-[80vw]">

                        {/* front */}
                        <div className="frontBox shadow-md flex flex-col items-center w-[75vw]  sm:w-[55vw] md:w-[62vw] md:h-[350px] lg:w-[55vw] lg:h-[450px] xl:h-[500px] xl:w-[55vw] 2xl:h-[716px] 2xl:w-[60vw]  bg-white border-8 border-[#D45659] left-0 right-0 mx-auto rounded-[1.5rem] px-[2rem]">
                            {/* head */}
                            <div className="head sm:w-[300px] md:w-[400px] lg:w-[500px] xl:w-[600px] 2xl:w-[723px] flex flex-col items-center">

                                <div className="heading sm:text-[1.8rem] sm:leading-[2rem] md:text-[2.2rem] md:leading-[2.8rem] lg:text-[2.5rem] lg:leading-[3rem] xl:text-[3rem] xl:leading-[4rem] 2xl:text-[5rem] 2xl:leading-[10rem] text-[#D45659] p-2 font-bold z-50 text-lg">Payment Unsuccessful !</div>

                                <div className="description sm:text-[12px] sm:leading-[22px] md:text-[13px] md:leading-[24px] lg:text-[14px] lg:leading-[26px] xl:text-[16px] xl:leading-[32px] 2xl:text-[22px] 2xl:leading-[44px] font-semibold text-center text-semibold z-50 text-xs">
                                    <p>
                                        {`You have signed up ErrorPagefully to your ${plans[plan]}. We have sent you an email with details on`} <a href="/" className='text-[#D45659] cursor-pointer'>email@email.com</a>
                                    </p>
                                </div>
                            </div>
                            <img src={characters} className="sm:h-[190px] md:h-[220px] lg:h-[320px] xl:h-[330px] 2xl:h-[435px] object-contain" alt="" />

                        </div>


                    </div>
            }


        </div>
    )
}

export default ErrorPage